import React, {useEffect, useRef, useState} from "react";
import apiClient from "../axios/axiosInterceptor";
import Dialog from "@mui/material/Dialog";
import {Box, FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import DialogFormActions from "../shared/DialogFormActions";

function SpeechModelCreate({model, onClose, onSubmit}) {
    const [name, setName] = useState(model ? model.name : '');
    const [sttServiceProviderId, setSttServiceProviderId] = useState(model ? model.sttServiceProviderId : '');

    const [sttServiceProviders, setSttServiceProviders] = useState([]);

    const dialogRef = useRef(null);

    useEffect(() => {
        const fetchRoles = async () => {
            const url = `/sttServiceProviders`;
            const response = await apiClient.get(url);
            setSttServiceProviders(response.data.list);
        };

        fetchRoles();
    }, []);

    const handleSubmit = e => {
        e.preventDefault();
        onSubmit({name, sttServiceProviderId});
    };

    const handleClose = (event: {}, reason: "backdropClick" | "escapeKeyDown") => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
        }
        onClose();
    };

    return (
        <React.Fragment>
            <Dialog
                open={true}
                onClose={handleClose}
                className="core-dialog"
            >
                <Box ref={dialogRef}>
                    <DialogTitle sx={{fontWeight: 'bold'}}>{model ? 'Edit' : 'Create'} Voice</DialogTitle>
                    <form
                        onSubmit={handleSubmit}
                        style={{display: 'contents'}}
                        className="core-form"
                    >
                        <DialogContent className="core-dialog-content">
                            <div className="core-form-row-item">
                                <TextField
                                    autoFocus
                                    required
                                    margin="dense"
                                    id="name"
                                    label="Name"
                                    name="name"
                                    variant="standard"
                                    value={name}
                                    fullWidth
                                    onChange={e => setName(e.target.value)}
                                />
                            </div>

                            <div className="core-form-row-item">
                                <FormControl fullWidth>
                                    <InputLabel id="sttServiceProviderLabel">Select a Language</InputLabel>
                                    <Select
                                        labelId="sttServiceProviderLabel"
                                        id="sttServiceProvider"
                                        value={sttServiceProviderId}
                                        label="Language"
                                        onChange={e => setSttServiceProviderId(parseInt(e.target.value))}
                                        variant={'outlined'}
                                    >
                                        {sttServiceProviders.map(sttServiceProvider => (
                                            <MenuItem value={sttServiceProvider.id}>{sttServiceProvider.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                        </DialogContent>
                        <DialogFormActions dialogRef={dialogRef} onClose={onClose}></DialogFormActions>
                    </form>
                </Box>
            </Dialog>
        </React.Fragment>
    );
}

export default SpeechModelCreate;
